// import React, { useState, useEffect } from 'react';
// import { Button, Modal } from 'antd';
// import { questions } from './Test/Questions'

// const Test = () => {
//   const [score, setScore] = useState(0);
//   const [currentQuestion, setCurrentQuestion] = useState(0);
//   const [answerId, setAnswerId] = useState();
//   const [isAnswered, setIsAnswered] = useState(false);
//   const [showScore, setShowScore] = useState(false);
//   const [complatedAnswerIds, setComplatedAnswersIds] = useState([]);
//   const [randomNumber, setRandomNumber] = useState(0);
//   const [scorePercent, setScorePercent] = useState(0);
//   const quizLimite = 100;

//   const checkAnswer = (item) => {
//     setIsAnswered(true);
//     setAnswerId(item.id);
//     if (item.isCorrect) {
//       setScore((score) => score + 1);
//     }
//   };
//   const tryAgain = () => {
//     setShowScore(false);
//     setScore(0);
//     setIsAnswered(false);
//     randomQuestion();
//     setCurrentQuestion(() => 0);
//   };

//   const nextQeustion = () => {
//     if (!isAnswered) {
//       alert("siz savolga javob bermadingiz iltimos javob bering");
//       return;
//     }
//     if (currentQuestion < questions.length - 1) {
//       setCurrentQuestion(currentQuestion + 1);
//       setIsAnswered(!isAnswered);
//     }
//     randomQuestion();
//   };

//   const getResult = () => {
//     setShowScore(!showScore);
//     setComplatedAnswersIds([]);

//     setScorePercent(Math.floor((score / quizLimite) * 100));
//   };

//   const getRandomNumber = () => {
//     return Math.floor(Math.random() * questions.length);
//   };

//   const randomQuestion = () => {
//     const randomNum = getRandomNumber();

//     if (!complatedAnswerIds.includes(randomNum)) {
//       setComplatedAnswersIds((p) => [...p, randomNum]);
//       setRandomNumber(randomNum);
//     } else {
//       randomQuestion();
//     }
//   };

//   useEffect(() => {
//     setRandomNumber(getRandomNumber());
//   }, []);


//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const showModal = () => {
//     setIsModalOpen(true);
//   };

//   const handleOk = () => {
//     setIsModalOpen(false);
//   };

//   const handleCancel = () => {
//     setIsModalOpen(false);
//   };

//   return (
//     <div className=" card">

//       <Button className='button' onClick={showModal}>
//         Testlar
//       </Button>
//       <Modal
//         className="custom-modal"
//         open={isModalOpen}
//         onOk={handleOk}
//         onCancel={handleCancel}
//         footer={null}>
//         <div>
//           {showScore ? (
//             <div className='modal'>
//               <div className="border-[2px] border-[solid] border-[grey] rounded-md py-4 px-3">
//                 <h1 className="text-4xl">Test yakunlandi</h1>
//                 <p className="text-3xl">
//                   To'g'ri javoblar soni: {score} <br />
//                   Umumiy savollar soni: {quizLimite} <br />
//                 </p>
//                 <div className="relative border-[solid] border-[1px] border-[grey] rounded-lg min-w-[250px] max-w-[400px] my-3 h-9 flex items-center overflow-hidden">
//                   <div
//                     style={{ width: `${scorePercent}%` }}
//                     className={
//                       "text-[15px] relative h-9 flex items-center justify-center text-slate-50 font-bold overflow-hidden " +
//                       (scorePercent < 56 ? "bg-red-600" : "") +
//                       (scorePercent > 55 && scorePercent < 71
//                         ? "bg-yellow-600"
//                         : "") +
//                       (scorePercent > 70 && scorePercent < 86
//                         ? "bg-green-600"
//                         : "") +
//                       (scorePercent > 85 ? "bg-[green]" : "")
//                     }
//                   >
//                     {scorePercent}%
//                   </div>
//                 </div>
//                 <div className="sm:text-[40px] text-[30px]">
//                   {scorePercent < 56 ? (
//                     <h1 className="">Natijangiz yaxshi emas!</h1>
//                   ) : (
//                     <h1> </h1>
//                   )}
//                   {scorePercent > 55 && scorePercent < 71 ? (
//                     <h1 className="">Sizning bahoingiz 3</h1>
//                   ) : (
//                     <h1> </h1>
//                   )}
//                   {scorePercent > 70 && scorePercent < 86 ? (
//                     <h1 className="">Sizning bahoingiz 4</h1>
//                   ) : (
//                     <h1> </h1>
//                   )}
//                   {scorePercent > 85 ? (
//                     <h1 className="">Sizning bahoingiz 5</h1>
//                   ) : (
//                     <h1> </h1>
//                   )}
//                 </div>
//                 <Button
//                   className="button w-[250px] mt-4"
//                   variant="contained"
//                   onClick={tryAgain}
//                 >
//                   qayta topshirish
//                 </Button>
//               </div>
//             </div>
//           ) : (
//             <div className='modal'>
//               <h3 className="text-3xl font-bold italic">
//                 Savol - {currentQuestion + 1}/{quizLimite}
//               </h3>
//               <h3 //className="cursor-help text-3xl font-bold py-2"
//               >
//                 {questions[randomNumber].questionText}
//               </h3>
//               <div>
//                 {questions[randomNumber].answerOptions.map((item) => (
//                   <div
//                     key={item.id}
//                     className={
//                       "bg-[rgba(209,209,209,0.4)] cursor-pointer answerItem " +
//                       (isAnswered && answerId === item.id
//                         ? item.isCorrect
//                           ? " "
//                           : "wrongAnswer "
//                         : "") +
//                       (isAnswered ? "disable " : "") +
//                       (isAnswered && item.isCorrect ? "currectAnswer " : "")
//                     }
//                     onClick={() => checkAnswer(item)}
//                   >
//                     {item.answerText}
//                   </div>
//                 ))}
//               </div>
//               <div className='buttons'>

//                 <Button
//                   disabled={currentQuestion === quizLimite - 1}
//                   variant="outlined"
//                   onClick={nextQeustion}
//                   className="button py-4"
//                   sx={{
//                     margin: "5px 0px",
//                   }}
//                 >
//                   keyingi savol
//                 </Button>
//                 <Button
//                   variant="contained"
//                   onClick={tryAgain}
//                   className="button my-4 border-[solid] border-[1px] border-[red] "
//                   sx={{
//                     margin: "5px 0px",
//                   }}
//                 >
//                   qayta topshirish
//                 </Button>
//                 <Button
//                   className='button'
//                   variant="contained"
//                   onClick={getResult}
//                   sx={{
//                     margin: "5px 0px",
//                   }}
//                 >
//                   Natijani ko'rish
//                 </Button>
//               </div>
//             </div>
//           )}
//         </div>
//       </Modal>
//     </div>
//   );
// };

// export default Test




// import React, { useState, useEffect } from 'react';
// import { Button, Modal } from 'antd';
// import { questions } from './Test/Questions';

// const Test = () => {
//   const [score, setScore] = useState(0);
//   const [currentQuestion, setCurrentQuestion] = useState(0);
//   const [answerId, setAnswerId] = useState();
//   const [isAnswered, setIsAnswered] = useState(false);
//   const [showScore, setShowScore] = useState(false);
//   const [complatedAnswerIds, setComplatedAnswersIds] = useState([]);
//   const [randomNumber, setRandomNumber] = useState(0);
//   const [scorePercent, setScorePercent] = useState(0);

//   // ✅ testlar soni avtomatik olinadi
//   const totalQuestions = questions.length;

//   const checkAnswer = (item) => {
//     setIsAnswered(true);
//     setAnswerId(item.id);
//     if (item.isCorrect) {
//       setScore((score) => score + 1);
//     }
//   };

//   const tryAgain = () => {
//     setShowScore(false);
//     setScore(0);
//     setIsAnswered(false);
//     randomQuestion();
//     setCurrentQuestion(0);
//   };

//   const nextQeustion = () => {
//     if (!isAnswered) {
//       alert("Siz savolga javob bermadingiz, iltimos javob bering");
//       return;
//     }
//     if (currentQuestion < totalQuestions - 1) {
//       setCurrentQuestion(currentQuestion + 1);
//       setIsAnswered(false);
//     }
//     randomQuestion();
//   };

//   const getResult = () => {
//     setShowScore(true);
//     setComplatedAnswersIds([]);
//     setScorePercent(Math.floor((score / totalQuestions) * 100));
//   };

//   const getRandomNumber = () => {
//     return Math.floor(Math.random() * questions.length);
//   };

//   const randomQuestion = () => {
//     const randomNum = getRandomNumber();
//     if (!complatedAnswerIds.includes(randomNum)) {
//       setComplatedAnswersIds((p) => [...p, randomNum]);
//       setRandomNumber(randomNum);
//     } else {
//       randomQuestion();
//     }
//   };

//   useEffect(() => {
//     setRandomNumber(getRandomNumber());
//   }, []);

//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const showModal = () => {
//     setIsModalOpen(true);
//   };

//   const handleOk = () => {
//     setIsModalOpen(false);
//   };

//   const handleCancel = () => {
//     setIsModalOpen(false);
//   };

//   return (
//     <div className="card flex justify-center items-center p-6">
//       <Button
//         className='button'
//         onClick={showModal}
//       >
//         Testlar
//       </Button>

//       <Modal
//         className="custom-modal"
//         open={isModalOpen}
//         onOk={handleOk}
//         onCancel={handleCancel}
//         footer={null}
//         centered
//       >
//         <div className="p-4">
//           {showScore ? (
//             <div className="text-center">
//               <div className="border-[2px] border-[solid] border-[grey] rounded-md py-4 px-3">
//                 <h1 className="text-4xl">✅ Test Yakunlandi</h1>
//                 <p className="text-3xl">
//                   Siz{" "}
//                   <span className="font-semibold">{totalQuestions}</span> ta
//                   testdan{" "}
//                   <span className="text-blue-600 font-bold">{score}</span> tasini
//                   to‘g‘ri topdingiz ✅
//                 </p>

//                 {/* progress bar */}
//                 <div className="relative border rounded-lg w-full max-w-[400px] mx-auto h-10 flex items-center overflow-hidden">
//                   <div
//                     style={{ width: `${scorePercent}%` }}
//                     className={
//                       "h-10 flex items-center justify-center text-white font-bold transition-all duration-500 " +
//                       (scorePercent < 56 ? "bg-red-500" : "") +
//                       (scorePercent > 55 && scorePercent < 71 ? "bg-yellow-500" : "") +
//                       (scorePercent > 70 && scorePercent < 86 ? "bg-green-500" : "") +
//                       (scorePercent > 85 ? "bg-emerald-600" : "")
//                     }
//                   >
//                     {scorePercent}%
//                   </div>
//                 </div>

//                 {/* baho chiqarish */}
//                 <div className="mt-6 text-2xl">
//                   {scorePercent < 56 && (
//                     <h1 className="text-red-600">Natijangiz yaxshi emas!</h1>
//                   )}
//                   {scorePercent > 55 && scorePercent < 71 && (
//                     <h1 className="text-yellow-600">Sizning bahoingiz: 3</h1>
//                   )}
//                   {scorePercent > 70 && scorePercent < 86 && (
//                     <h1 className="text-green-600">Sizning bahoingiz: 4</h1>
//                   )}
//                   {scorePercent > 85 && (
//                     <h1 className="text-emerald-600">Sizning bahoingiz: 5</h1>
//                   )}
//                 </div>

//                 <Button
//                   type="primary"
//                   size="large"
//                   className="button w-[250px] mt-4"
//                   onClick={tryAgain}
//                 >
//                   🔄 Qayta Topshirish
//                 </Button>
//               </div>
//             </div>
//           ) : (

//             <div className='modal'>
//               <h3 className="text-3xl font-bold italic">
//                 Savol - {currentQuestion + 1}/{totalQuestions}
//               </h3>
//               <h3 //className="cursor-help text-3xl font-bold py-2"
//               >
//                 {questions[randomNumber].questionText}
//               </h3>
//               <div>
//                 {questions[randomNumber].answerOptions.map((item) => (
//                   <div
//                     key={item.id}
//                     className={
//                       "bg-[rgba(209,209,209,0.4)] cursor-pointer answerItem " +
//                       (isAnswered && answerId === item.id
//                         ? item.isCorrect
//                           ? " "
//                           : "wrongAnswer "
//                         : "") +
//                       (isAnswered ? "disable " : "") +
//                       (isAnswered && item.isCorrect ? "currectAnswer " : "")
//                     }
//                     onClick={() => checkAnswer(item)}
//                   >
//                     {item.answerText}
//                   </div>
//                 ))}
//               </div>
//               <div className='buttons'>

//                 <Button
//                   disabled={currentQuestion === totalQuestions- 1}
//                   variant="outlined"
//                   onClick={nextQeustion}
//                   className="button py-4"
//                   sx={{
//                     margin: "5px 0px",
//                   }}
//                 >
//                   keyingi savol
//                 </Button>
//                 <Button
//                   variant="contained"
//                   onClick={tryAgain}
//                   className="button my-4 border-[solid] border-[1px] border-[red] "
//                   sx={{
//                     margin: "5px 0px",
//                   }}
//                 >
//                   qayta topshirish
//                 </Button>
//                 <Button
//                   className='button'
//                   variant="contained"
//                   onClick={getResult}
//                   sx={{
//                     margin: "5px 0px",
//                   }}
//                 >
//                   Natijani ko'rish
//                 </Button>
//               </div>
//             </div>



//             // <div className='modal'>
//             //   <h3 className="text-2xl font-bold mb-3 text-center">
//             //     Savol - {currentQuestion + 1}/{totalQuestions}
//             //   </h3>
//             //   <h3 className="text-lg font-medium mb-4 text-gray-800 text-center">
//             //     {questions[randomNumber].questionText}
//             //   </h3>
//             //   <div className="space-y-3">
//             //     {questions[randomNumber].answerOptions.map((item) => (
//             //       <div
//             //         key={item.id}
//             //         className={
//             //           "p-3 rounded-lg border cursor-pointer transition-all " +
//             //           "hover:bg-blue-50 " +
//             //           (isAnswered && answerId === item.id
//             //             ? item.isCorrect
//             //               ? ""
//             //               : "wrongAnswer"
//             //             : "") +
//             //           (isAnswered && item.isCorrect
//             //             ? "  "
//             //             : "currectAnswer")
//             //         }
//             //         onClick={() => checkAnswer(item)}
//             //       >
//             //         {item.answerText}
//             //       </div>
//             //     ))}
//             //   </div>

//             //   <div className="flex flex-col mt-6 gap-3">
//             //     <Button
//             //       disabled={currentQuestion === totalQuestions - 1}
//             //       onClick={nextQeustion}
//             //       className="button py-4 "
//             //     >
//             //       ⏭ Keyingi savol
//             //     </Button>
//             //     <Button danger onClick={tryAgain} className="button my-4 border-[solid] border-[1px] border-[red]">
//             //       🔄 Qayta Topshirish
//             //     </Button>
//             //     <Button
//             //       type="primary"
//             //       onClick={getResult}
//             //       className="button"
//             //     >
//             //       📊 Natijani ko‘rish
//             //     </Button>
//             //   </div>
//             // </div>


//           )}
//         </div>
//       </Modal>
//     </div>
//   );
// };

// export default Test;


import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'antd';
import { questions } from './Test/Questions';

const Test = () => {
  const [score, setScore] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answerId, setAnswerId] = useState();
  const [isAnswered, setIsAnswered] = useState(false);
  const [showScore, setShowScore] = useState(false);
  const [complatedAnswerIds, setComplatedAnswersIds] = useState([]);
  const [randomNumber, setRandomNumber] = useState(0);
  const [scorePercent, setScorePercent] = useState(0);
  const [answeredQuestions, setAnsweredQuestions] = useState(0); // ✅ qo‘shildi

  // testlar soni
  const totalQuestions = questions.length;

  const checkAnswer = (item) => {
    setIsAnswered(true);
    setAnswerId(item.id);
    setAnsweredQuestions((prev) => prev + 1); // ✅ javob berilgan savollarni sanaymiz
    if (item.isCorrect) {
      setScore((score) => score + 1);
    }
  };

  const tryAgain = () => {
    setShowScore(false);
    setScore(0);
    setAnsweredQuestions(0); // ✅ reset
    setIsAnswered(false);
    randomQuestion();
    setCurrentQuestion(0);
  };

  const nextQeustion = () => {
    if (!isAnswered) {
      alert("Siz savolga javob bermadingiz, iltimos javob bering");
      return;
    }
    if (currentQuestion < totalQuestions - 1) {
      setCurrentQuestion(currentQuestion + 1);
      setIsAnswered(false);
    }
    randomQuestion();
  };

  const getResult = () => {
    setShowScore(true);
    setComplatedAnswersIds([]);
    // ✅ faqat javob berilgan savollar bo‘yicha hisoblanadi
    setScorePercent(
      answeredQuestions > 0 ? Math.floor((score / answeredQuestions) * 100) : 0
    );
  };

  const getRandomNumber = () => {
    return Math.floor(Math.random() * questions.length);
  };

  const randomQuestion = () => {
    const randomNum = getRandomNumber();
    if (!complatedAnswerIds.includes(randomNum)) {
      setComplatedAnswersIds((p) => [...p, randomNum]);
      setRandomNumber(randomNum);
    } else {
      randomQuestion();
    }
  };

  useEffect(() => {
    setRandomNumber(getRandomNumber());
  }, []);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="card flex justify-center items-center p-6">
      <Button
        className='button'
        onClick={showModal}
      >
        Testlar
      </Button>

      <Modal
        className="custom-modal"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        centered
      >
        <div className="p-4">
          {showScore ? (
            <div className="text-center">
              <div className="border-[2px] border-[solid] border-[grey] rounded-md py-4 px-3">
                <h1 className="text-4xl">✅ Test Yakunlandi</h1>
                <p className="text-3xl">
                  Siz{" "}
                  <span className="font-semibold">{answeredQuestions}</span> ta
                  testdan{" "}
                  <span className="text-blue-600 font-bold">{score}</span> tasini
                  to‘g‘ri topdingiz ✅
                </p>

                {/* progress bar */}
                <div className="relative border rounded-lg w-full max-w-[400px] mx-auto h-10 flex items-center overflow-hidden">
                  <div
                    style={{ width: `${scorePercent}%` }}
                    className={
                      "h-10 flex items-center justify-center text-white font-bold transition-all duration-500 " +
                      (scorePercent < 56 ? "bg-red-500" : "") +
                      (scorePercent > 55 && scorePercent < 71 ? "bg-yellow-500" : "") +
                      (scorePercent > 70 && scorePercent < 86 ? "bg-green-500" : "") +
                      (scorePercent > 85 ? "bg-emerald-600" : "")
                    }
                  >
                    {scorePercent}%
                  </div>
                </div>

                {/* baho chiqarish */}
                <div className="mt-6 text-2xl">
                  {scorePercent < 56 && (
                    <h1 className="text-red-600">Natijangiz yaxshi emas!</h1>
                  )}
                  {scorePercent > 55 && scorePercent < 71 && (
                    <h1 className="text-yellow-600">Sizning bahoingiz: 3</h1>
                  )}
                  {scorePercent > 70 && scorePercent < 86 && (
                    <h1 className="text-green-600">Sizning bahoingiz: 4</h1>
                  )}
                  {scorePercent > 85 && (
                    <h1 className="text-emerald-600">Sizning bahoingiz: 5</h1>
                  )}
                </div>

                <Button
                  type="primary"
                  size="large"
                  className="button w-[250px] mt-4"
                  onClick={tryAgain}
                >
                  🔄 Qayta Topshirish
                </Button>
              </div>
            </div>
          ) : (

            <div className='modal'>
              <h3 className="text-3xl font-bold italic">
                Savol - {currentQuestion + 1}/{totalQuestions}
              </h3>
              <h3>
                {questions[randomNumber].questionText}
              </h3>
              <div>
                {questions[randomNumber].answerOptions.map((item) => (
                  <div
                    key={item.id}
                    className={
                      "bg-[rgba(209,209,209,0.4)] cursor-pointer answerItem " +
                      (isAnswered && answerId === item.id
                        ? item.isCorrect
                          ? " "
                          : "wrongAnswer "
                        : "") +
                      (isAnswered ? "disable " : "") +
                      (isAnswered && item.isCorrect ? "currectAnswer " : "")
                    }
                    onClick={() => checkAnswer(item)}
                  >
                    {item.answerText}
                  </div>
                ))}
              </div>
              <div className='buttons'>

                <Button
                  disabled={currentQuestion === totalQuestions- 1}
                  variant="outlined"
                  onClick={nextQeustion}
                  className="button py-4"
                >
                  keyingi savol
                </Button>
                <Button
                  variant="contained"
                  onClick={tryAgain}
                  className="button my-4 border-[solid] border-[1px] border-[red] "
                >
                  qayta topshirish
                </Button>
                <Button
                  className='button'
                  variant="contained"
                  onClick={getResult}
                >
                  Natijani ko'rish
                </Button>
              </div>
            </div>

          )}
        </div>
      </Modal>
    </div>
  );
};

export default Test;
